module.exports = __webpack_public_path__ + "static/media/5.be825900.png";